export const globalSettings = {
  project: 'ClientPortal',
  // `horizon-app-header` renders this logo HTML block.
  logo: `<span class="icon-item" title=""><svg width="355" height="42" viewBox="0 0 355 42" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Pepper">
    <image href="/assets/prism/logo/header-logo.svg" x="-80" y="0" width="355" height="42" preserveAspectRatio="xMinYMid meet"></image>
  </svg></span>`,
  loadingImage: 'loading_app_image.png',
  colors: {
    mainColor: ' #002841',
    secondaryColor: '#002841',
    tertiaryColor: '#35ABC6',
    complementaryColor: '#002841',
    blackColor: '#000000',
    whiteColor: '#FFFFFF',
    pepperColor: ' #002841',
    errorColor: '#BE020B',
    successColor: '#058303',
    warningColor: '#ED8B00',
    neutralDarkColor: '#9D9D9D',
    neutralRegularColor: '#BDBDBD',
    neutralLightColor: '#E0E0E0',
    neutralExtraLightColor: '#FAFAFA',
  },
};
